import { render, staticRenderFns } from "./EmojiPicker.vue?vue&type=template&id=0c41f24b&"
import script from "./EmojiPicker.vue?vue&type=script&lang=js&"
export * from "./EmojiPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports